// extracted by mini-css-extract-plugin
export var active = "_s5-1";
export var circle = "_s5-0";
export var completed = "_s5-2";
export var connector = "_s5-4";
export var connectorCompleted = "_s5-7";
export var connectorSpacer = "_s5-5";
export var iconStrokeOverride = "_s5-8";
export var labelContainer = "_s5-6";
export var pending = "_s5-3";